import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { GameState } from '../../../../services/api';
import GameLink from './components/GameLink/GameLink';
import PlayersDropdown from './components/PlayersDropdown';
import ActionButton from '../../../Common/ActionButton';

interface Props {
  gameState: GameState,
  onProceed: () => void,
  isStarting: boolean
}

const GameLobby: React.FC<Props> = ({gameState, onProceed, isStarting}) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (gameState && gameState.state !== 'lobby') {
      navigate("/");
    }
  }, [gameState, navigate]);

  const isHost = gameState.isHost;
  const canStart = gameState.players.length >= 3;



  return (
    <div className="flex-1 flex flex-col gap-8 sm:gap-10">
      {/* Players Section */}
      <div className="w-full">
        <PlayersDropdown players={gameState.players} isHost={isHost} />
      </div>

      {/* Game Code and QR Section */}
      <GameLink gameCode={gameState.gameCode} />
      
      {/* Action Section */}
      <div className="text-center">
        {isHost ? (
          <div className="space-y-3 sm:space-y-4">
            {!canStart && (
              <p className="text-red-600 font-medium bg-red-50/80 backdrop-blur-sm rounded-lg sm:rounded-xl p-2 sm:p-3 border border-red-200 text-sm sm:text-base mx-2 sm:mx-0">
                Need at least 3 players to start the game
              </p>
            )}
            <ActionButton
              onClick={onProceed}
              disabled={!canStart}
              loading={isStarting}
              variant="primary"
              size="lg"
            >
              START GAME
            </ActionButton>
          </div>
        ) : (
          <div className="w-full bg-white/80 backdrop-blur-sm rounded-xl sm:rounded-2xl p-4 sm:p-6 shadow-lg border border-white/20">
            <p className="text-gray-600 text-base sm:text-lg font-medium">
              Waiting for host to start the game
            </p>
          </div>
        )}
      </div>
    </div>
  )
};

export default GameLobby;